<script>
	import { onMount } from 'svelte';
	import ComponentPageHead from '$lib/components/ComponentPageHead.svelte';
	export let data;
	const { page } = data;
	/**
	 * @type {typeof import('svelte').SvelteComponent}
	 */
	let Component;
	let metadata = data.metadata;

	onMount(async () => {
		Component = await page?.init();
		if (page) metadata = { ...page.metadata };
	});
</script>

{#key metadata}
	<ComponentPageHead content={metadata} />
{/key}

{#if Component}
	<svelte:component
		this={Component}
		pageData={data}
	/>
{/if}
